module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiM5QjlCOUIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE0LjM5NCAxNkw4IDkuNjA2IDEuNjA2IDE2IDAgMTQuMzk0IDYuMzk0IDggMCAxLjYwNiAxLjYwNiAwIDggNi4zOTQgMTQuMzk0IDAgMTYgMS42MDYgOS42MDYgOCAxNiAxNC4zOTR6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x.svg
// module id = 936
// module chunks = 0